import React, { useState } from 'react';
import { useUser } from '../context/userContext';
import { useRooms } from '../context/RoomsContext';
import { convertCelsiusToFahrenheit } from '../utils/helpers';
import { fetchApi } from '../utils/fetchApi';
import { useTranslation } from 'react-i18next';
import { FaPencilAlt, FaCheck } from 'react-icons/fa';

interface TemperatureCardProps {
  room?: string;
  thermostatId: number;
  temperature: number | string;
  humidity?: number | string;
  measuredTemperature: number | string;
  heatOrFreeze?: 'heat' | 'freeze';
  coolingDisabledDewPoint?: boolean;
  onClick?: React.MouseEventHandler;
}

const TemperatureCard: React.FC<TemperatureCardProps> = ({
  room,
  thermostatId,
  temperature,
  humidity,
  heatOrFreeze,
  measuredTemperature,
  coolingDisabledDewPoint,
  onClick
}) => {
  const { unit } = useUser();
  const { rooms, setRooms } = useRooms();
  const { t } = useTranslation();

  const [isEditing, setIsEditing] = useState(false);
  const [editedRoomName, setEditedRoomName] = useState(room || '');

  const displayTemperature = unit === 'Fahrenheit' ? convertCelsiusToFahrenheit(temperature as number) : temperature;
  const displayMeasuredTemperature = unit === 'Fahrenheit' ? convertCelsiusToFahrenheit(measuredTemperature as number) : measuredTemperature;

  const unitSymbol = unit === 'Fahrenheit' ? '°F' : '°C';

  const handleSaveName = async () => {
    try {
      await fetchApi('update_thermostat_settings', {
        thermostat_id: thermostatId,
        new_name: editedRoomName,
      });

      setRooms(rooms.map((r) =>
        r.thermostatId === thermostatId ? { ...r, name: editedRoomName } : r
      ));

      setIsEditing(false);
    } catch (error) {
      console.error('Error updating room name:', error);
    }
  };

  const handleEditName = (event: React.MouseEvent) => {
    event.stopPropagation();
    setIsEditing(true)
  }

  return (
    <div className={`temperatureCard ${coolingDisabledDewPoint ? "dewPointDisabled" : ""}`} onClick={onClick}>
      {temperature && <p className={`temperature ${heatOrFreeze}`}>{displayTemperature}{unitSymbol}</p>}
      {humidity && <p className="humidity">{t('humidity')}: {humidity}%</p>}
      {measuredTemperature && <p className="humidity">{t('measuredTemperature')}: {displayMeasuredTemperature}{unitSymbol}</p>}
      <div className="roomName">
        {isEditing ? (
          <input
            type="text"
            value={editedRoomName}
            onChange={(e) => setEditedRoomName(e.target.value)}
            onBlur={handleSaveName}
            autoFocus
          />
        ) : (
          <h3 onClick={(event) => {handleEditName(event)}}>{editedRoomName}</h3>
        )}
        <button onClick={(event) => isEditing ? handleSaveName() : handleEditName(event)}>
          {isEditing ? <FaCheck /> : <FaPencilAlt />}
        </button>
      </div>
    </div>
  );
};

export default TemperatureCard;
